import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

const Success = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isLoaded, isSignedIn, user } = useUser();
  const [error, setError] = useState(null);
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const updatePaymentStatus = async () => {
      try {
        if (!isLoaded || !isSignedIn) {
          throw new Error('User not authenticated');
        }

        // Check for payment ID, invoice ID, or development mode
        const paymentId = searchParams.get('paymentId');
        const invoiceId = searchParams.get('invoice_id') || searchParams.get('iid');
        const isDevelopment = searchParams.get('development') === 'true';

        if (!paymentId && !invoiceId && !isDevelopment) {
          throw new Error('Invalid payment verification');
        }

        // Log for development testing
        if (isDevelopment) {
          console.log('Development mode: Updating payment status without verification');
        }

        // Update user metadata with payment information
        await user.update({
          publicMetadata: {
            has_paid: true,
            paymentDate: new Date().toISOString(),
            paymentId: paymentId || invoiceId || 'development'
          }
        });

        setVerifying(false);
        // Redirect to course page after 3 seconds
        setTimeout(() => {
          navigate('/course');
        }, 3000);

      } catch (err) {
        console.error('Error updating payment status:', err);
        setError(err.message);
        setVerifying(false);
      }
    };

    if (isLoaded) {
      updatePaymentStatus();
    }
  }, [isLoaded, isSignedIn, user, navigate, searchParams]);

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <div className="success-container">
      <div className="success-content">
        {verifying ? (
          <>
            <h2>Verifying Payment...</h2>
            <p>Please wait while we verify your payment.</p>
          </>
        ) : error ? (
          <>
            <h2>Payment Verification Failed</h2>
            <div className="error-message">
              {error}
            </div>
            <button onClick={() => navigate('/')}>Return to Home</button>
          </>
        ) : (
          <>
            <h1>Payment Successful! 🎉</h1>
            <p>Thank you for your purchase. Your course access has been activated.</p>
            <p>Redirecting to course page...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Success; 